
import store from '@/store/index'
import router from '@/router/index'
import axios from 'axios'

const client = axios.create({
    baseURL: process.env.URL_API,
    headers: {
        'Accept-Language': window.localStorage.getItem('pml_lang') || 'en-US'
    }
})

client.interceptors.response.use(
    (response) => response,
    (error) => {
        if (error.response.status === 401)
            store.dispatch('clientLogout')
                .then(() => router.push('/login'))

        if (error.response.status === 403)
            router.push({ name: 'error.403' })

        if (error.response.status === 404)
            router.push({ name: 'error.404' })

        if (error.response.status === 500)
            router.push({ name: 'error.500' })

        return Promise.reject(error)
    }
)

export default client



// WEBPACK FOOTER //
// ./src/utils/http/index.js